import { Conductor, Promotions } from "src/models";
import { ArchiveListTypes } from "../types/archive.list.types";
import { createAction } from "./create.action";

export namespace ArchiveListAction {

    export const showLoading = () => createAction(ArchiveListTypes.SHOW_ARCHIVE_LIST_LOADING);
    export const hideLoading = () => createAction(ArchiveListTypes.HIDE_ARCHIVE_LIST_LOADING);

    export const getData = (count: number, type: number, offset: number, searchText?: string, clear?: boolean, clearBeforeFetch?: boolean) =>
        createAction(ArchiveListTypes.REQUEST_LOAD_ARCHIVE_LIST, { count, type, offset, searchText, clear, clearBeforeFetch });

    export const setData = (list: Conductor[], promotions: Promotions, clear: boolean, count: number, totalRecords: number) =>
        createAction(ArchiveListTypes.SET_ARCHIVE_LIST_DATA, { list, clear, count, totalRecords });

    export const setSearchText = (text: string) => createAction(ArchiveListTypes.SET_SEARCH_TEXT, text);

}